import React from "react";
import PropTypes from "prop-types";
import { Transition } from "react-transition-group";
import { DialogOverlay, DialogContent } from "@reach/dialog";
import classNames from "classnames";
/**
 * The one and eventually only modal component.
 * Lets not add more props and please don't create "medium-large", "x-small", etc options
 */

var Modal = function Modal(_ref) {
  var children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$closeModal = _ref.closeModal,
      closeModal = _ref$closeModal === void 0 ? function () {} : _ref$closeModal,
      _ref$closeOnOutsideCl = _ref.closeOnOutsideClick,
      closeOnOutsideClick = _ref$closeOnOutsideCl === void 0 ? false : _ref$closeOnOutsideCl,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size;
  var modalWidth = size === "fullscreen" ? "calc(100vw - 16px)" : size === "large" ? "800px" : size === "medium" ? "600px" : "400px";

  var handleOnDismiss = function handleOnDismiss(event) {
    if (closeOnOutsideClick || event.key === "Escape") {
      closeModal();
    }
  };

  return /*#__PURE__*/React.createElement(Transition, {
    in: isOpen,
    timeout: 200,
    unmountOnExit: true,
    mountOnEnter: true
  }, function (state) {
    return /*#__PURE__*/React.createElement(DialogOverlay, {
      isOpen: isOpen,
      onDismiss: handleOnDismiss
    }, /*#__PURE__*/React.createElement(DialogContent, {
      "aria-label": "modal window",
      className: classNames("et--modal", state),
      style: {
        width: modalWidth
      }
    }, children));
  });
};

Modal.propTypes = {
  children: PropTypes.any,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  closeOnOutsideClick: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large", "fullscreen"])
};
export default Modal;